import { render } from "./GradientButton.vue?vue&type=template&id=5a3dfc9c&scoped=true&ts=true"
import script from "./GradientButton.vue?vue&type=script&lang=ts"
export * from "./GradientButton.vue?vue&type=script&lang=ts"

import "./GradientButton.vue?vue&type=style&index=0&id=5a3dfc9c&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3dfc9c"]])

export default __exports__